<template>
  <div class="input-group input-range" v-if="filter.range">
    <input
      class="form-control"
      v-on:keydown.enter="keyDown"
      :type="filter.type"
      v-model.lazy="filter.data.start"
      :placeholder="filter.placeholderMin || 'En az' | trans"
    >
    <input
      class="form-control"
      v-on:keydown.enter="keyDown"
      :type="filter.type"
      v-model.lazy="filter.data.end"
      :placeholder="filter.placeholderMax || 'En fazla' | trans"
    >
  </div>

  <input
    v-else
    class="form-control mb-2"
    v-on:keydown.enter="keyDown"
    :type="filter.type"
    v-model.lazy="filter.data"
    :placeholder="filter.placeholder || 'Arama' | trans"
  >
</template>

<script>
  export default {
    props: ["filter"],
    methods: {
      keyDown() {
        setTimeout(() => {
          if (this.filter.data === '') {
            this.filter.data = null;
          }
          this.$emit('keydown', true)
        }, 50)
      },

      checkGreat() {
        if (!this.filter.data || !this.filter.data.start || !this.filter.data.end) {
          return;
        }

        if (parseInt(this.filter.data.start) > parseInt(this.filter.data.end)) {
          this.filter.data.start = this.filter.data.end;
          this.$buefy.dialog.alert({
            title: 'Hata',
            message: this.trans('Minimum değer Maximum değerden büyük olamaz!'),
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: false
          })
        }
      }
    },
    watch: {
      'filter.data.start'() {
        this.checkGreat();
      },
      'filter.data.end'() {
        this.checkGreat();
      }
    }
  }
</script>


